import { AuthModule } from "@/store/modules/auth";
import { Context } from "@/types/middleware.type";
export default function AuthMiddleware(context: Context) {
  if (!AuthModule.hasToken) {
    return context.router.push({ name: "Login" });
  }
  return context.next();
}
